import React, { useState, useEffect } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { isMobile } from 'react-device-detect';

import Home from '../pages/Usuario/Home';

import Listagem from '../pages/Usuario/Recomendacoes/Listagem';
import Vizualizar from '../pages/Usuario/Recomendacoes/Visualizar';

import ListagemSolicitacoes from '../pages/Usuario/Solicitacoes/Listagem';
import VisualizarSolicitacoes from '../pages/Usuario/Solicitacoes/Visualizar';

import MinhaConta from '../pages/Usuario/MinhaConta';

import Ajuda from '../pages/Usuario/Ajuda';

import UsuarioLogin from '../pages/Usuario/Login';

import Esqueci from '../pages/Usuario/Login/Esqueci';

import NovaSenha from '../pages/Usuario/Login/NovaSenha';

import TopMenu from '../components/TopMenu';
import SideMenu from '../components/SideMenu';

import NotFound from '../pages/404Page'

import Tickets from '../pages/Usuario/Suporte/ListagemTickets';
import CriarTicket from '../pages/Usuario/Suporte/CadastroTicket';
import jwt from 'jsonwebtoken';
import api from '../services/api';


interface UsuarioRoutesProps {
  useBasename: boolean;
};

function UsuarioRoutes(props: UsuarioRoutesProps) {
  const [device, setDevice] = useState('desktop');
  const signed = JSON.parse(localStorage.getItem('user') || 'false');
  const [movideskId, setMovideskId] = useState('');



  useEffect(() => {
    const token = (jwt.decode(localStorage.getItem('accessToken')!, { json: true })!)
    if (token) {
      const id = token.sub;
      if (id) {
        const getData = async () => {
          const response = await api.get('/users/' + id);
          if (response.status && response.status.toString()[0] === '2') {
            const data = await response.json();
            setMovideskId(data.company.movideskId);
          }
        };
        getData();
      }
    }
  }, []);

  useEffect(() => {
    if (isMobile) {
      setDevice('mobile');
    }
  }, []);

  const options = [
    {
      title: 'Home',
      link: '/home',
      icon:
        <svg width="25" height="25" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M29.7525 8.77766L15.2212 0.992937C15.1532 0.956425 15.0771 0.937317 14.9999 0.937317C14.9227 0.937317 14.8466 0.956425 14.7785 0.992937L0.2473 8.77766C0.137752 8.83638 0.0560101 8.9362 0.0200489 9.05518C-0.0159122 9.17415 -0.00314818 9.30254 0.0555343 9.41211L1.82591 12.7181C1.85484 12.7724 1.89425 12.8205 1.94186 12.8596C1.98948 12.8986 2.04435 12.9279 2.10332 12.9456C2.22234 12.9812 2.3506 12.9686 2.46036 12.9103L14.9999 6.19264L27.5394 12.9103C27.5937 12.9394 27.6532 12.9574 27.7144 12.9635C27.7757 12.9696 27.8375 12.9635 27.8965 12.9457C27.9554 12.9278 28.0102 12.8985 28.0578 12.8595C28.1054 12.8205 28.1448 12.7724 28.1739 12.7182L29.9443 9.4122C30.003 9.30263 30.0157 9.17421 29.9798 9.05521C29.9438 8.93622 29.8621 8.83638 29.7525 8.77766ZM27.569 11.8625L15.2212 5.24736C15.1531 5.21101 15.0771 5.192 14.9999 5.192C14.9227 5.192 14.8467 5.21101 14.7785 5.24736L2.43083 11.8625L1.1031 9.38281L14.9999 1.93822L28.8967 9.38281L27.569 11.8625Z" fill="white" />
          <path d="M25.3125 12.8435C25.1882 12.8435 25.069 12.8929 24.981 12.9808C24.8931 13.0687 24.8438 13.1879 24.8438 13.3123V24.8438H19.2188V16.4063C19.2188 16.282 19.1694 16.1627 19.0815 16.0748C18.9935 15.9869 18.8743 15.9375 18.75 15.9375H11.25C11.1257 15.9375 11.0065 15.9869 10.9185 16.0748C10.8306 16.1627 10.7812 16.282 10.7812 16.4063V24.8438H5.15625V13.3123C5.15625 13.1879 5.10686 13.0687 5.01896 12.9808C4.93105 12.8929 4.81182 12.8435 4.6875 12.8435C4.56318 12.8435 4.44395 12.8929 4.35604 12.9808C4.26814 13.0687 4.21875 13.1879 4.21875 13.3123V27.6563C4.21875 27.7806 4.26814 27.8998 4.35604 27.9877C4.44395 28.0756 4.56318 28.125 4.6875 28.125H25.3125C25.4368 28.125 25.556 28.0756 25.644 27.9877C25.7319 27.8998 25.7812 27.7806 25.7812 27.6563V13.3123C25.7812 13.1879 25.7319 13.0687 25.644 12.9808C25.556 12.8929 25.4368 12.8435 25.3125 12.8435ZM5.15625 25.7813H10.7812V27.1875H5.15625V25.7813ZM11.7188 16.875H18.2812V27.1875H11.7188V16.875ZM24.8438 27.1875H19.2188V25.7813H24.8438V27.1875Z" fill="white" />
          <path d="M17.3438 21.0938C17.2194 21.0938 17.1002 21.1431 17.0123 21.231C16.9244 21.319 16.875 21.4382 16.875 21.5625V22.0312C16.875 22.1556 16.9244 22.2748 17.0123 22.3627C17.1002 22.4506 17.2194 22.5 17.3438 22.5C17.4681 22.5 17.5873 22.4506 17.6752 22.3627C17.7631 22.2748 17.8125 22.1556 17.8125 22.0312V21.5625C17.8125 21.4382 17.7631 21.319 17.6752 21.231C17.5873 21.1431 17.4681 21.0938 17.3438 21.0938Z" fill="white" />
        </svg>,
      submenu: [],
    },
    {
      title: 'Minha Conta',
      link: '/conta',
      icon:
        <svg width="25" height="25" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 0.46875C12.126 0.46875 9.31653 1.32099 6.92688 2.91771C4.53723 4.51442 2.67472 6.78389 1.57488 9.43913C0.475046 12.0944 0.187279 15.0161 0.74797 17.8349C1.30866 20.6537 2.69263 23.2429 4.72486 25.2751C6.75709 27.3074 9.34631 28.6913 12.1651 29.252C14.9839 29.8127 17.9056 29.525 20.5609 28.4251C23.2161 27.3253 25.4856 25.4628 27.0823 23.0731C28.679 20.6835 29.5313 17.874 29.5313 15C29.5269 11.1474 27.9945 7.45386 25.2703 4.72966C22.5462 2.00547 18.8526 0.473105 15 0.46875ZM15 28.5938C12.3114 28.5938 9.6832 27.7965 7.44772 26.3028C5.21224 24.8091 3.4699 22.686 2.44102 20.2021C1.41214 17.7182 1.14294 14.9849 1.66746 12.348C2.19197 9.71106 3.48665 7.28889 5.38777 5.38777C7.28889 3.48665 9.71107 2.19197 12.348 1.66745C14.9849 1.14293 17.7182 1.41213 20.2021 2.44101C22.686 3.46989 24.8091 5.21224 26.3028 7.44772C27.7965 9.6832 28.5938 12.3114 28.5938 15C28.5897 18.604 27.1561 22.0593 24.6077 24.6077C22.0593 27.1561 18.604 28.5896 15 28.5938Z" fill="white" />
          <path d="M25.1182 21.9154C22.4069 19.2842 18.7773 17.8125 14.9991 17.8125C11.2209 17.8125 7.59132 19.2842 4.88002 21.9154C4.79182 22.0023 4.74158 22.1206 4.74026 22.2444C4.73894 22.3682 4.78665 22.4874 4.87298 22.5762C4.9593 22.6649 5.07723 22.7159 5.20102 22.718C5.32481 22.7201 5.4444 22.6732 5.53369 22.5874C8.07 20.1264 11.4651 18.75 14.9991 18.75C18.5331 18.75 21.9282 20.1264 24.4645 22.5874C24.5538 22.6732 24.6734 22.7201 24.7972 22.718C24.921 22.7159 25.0389 22.6649 25.1252 22.5762C25.2116 22.4874 25.2593 22.3682 25.258 22.2444C25.2566 22.1206 25.2064 22.0023 25.1182 21.9154Z" fill="white" />
          <path d="M15 15.9375C16.1125 15.9375 17.2001 15.6076 18.1251 14.9895C19.0501 14.3714 19.7711 13.4929 20.1968 12.4651C20.6226 11.4373 20.734 10.3063 20.5169 9.21512C20.2999 8.12398 19.7642 7.1217 18.9775 6.33503C18.1908 5.54836 17.1885 5.01263 16.0974 4.79559C15.0062 4.57854 13.8752 4.68994 12.8474 5.11568C11.8196 5.54142 10.9411 6.26239 10.323 7.18742C9.7049 8.11245 9.375 9.19998 9.375 10.3125C9.37666 11.8038 9.96983 13.2336 11.0244 14.2881C12.0789 15.3427 13.5087 15.9358 15 15.9375ZM15 5.625C15.9271 5.625 16.8334 5.89992 17.6042 6.41499C18.3751 6.93006 18.9759 7.66215 19.3307 8.51867C19.6855 9.3752 19.7783 10.3177 19.5974 11.227C19.4166 12.1363 18.9701 12.9715 18.3146 13.6271C17.659 14.2826 16.8238 14.7291 15.9145 14.9099C15.0052 15.0908 14.0627 14.998 13.2062 14.6432C12.3496 14.2884 11.6176 13.6876 11.1025 12.9167C10.5874 12.1459 10.3125 11.2396 10.3125 10.3125C10.3139 9.06973 10.8082 7.87827 11.687 6.9995C12.5658 6.12073 13.7572 5.62642 15 5.625Z" fill="white" />
        </svg>,
      submenu: [],
    },
    {
      title: 'Recomendação',
      link: '/recomendacoes',
      icon: <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M23.1898 4.63553L20.5601 2.12708V22.093V22.6388H19.9871H0.956905H0.383911V22.093V17.1913H1.5299V21.5473H19.4141V2.07551L16.7551 4.64449L15.9403 3.88133L19.5466 0.397172L19.9515 0.00610352L20.3592 0.395023L24 3.86808L23.1898 4.63553Z" fill="white" />
        <path d="M11.5 2H4.7C4.24913 2 3.81673 2.17911 3.49792 2.49792C3.17911 2.81673 3 3.24913 3 3.7V17.3C3 17.7508 3.17911 18.1832 3.49792 18.502C3.81673 18.8209 4.24913 19 4.7 19H14.9C15.3508 19 15.7832 18.8209 16.1021 18.502C16.4209 18.1832 16.6 17.7508 16.6 17.3V7.09999L11.5 2Z" stroke="#FEFBFB" />
        <path d="M11.5 2V7.09999H16.6" stroke="#FEFBFB" />
        <path d="M13.2 11.3501H6.40002" stroke="#FEFBFB" />
        <path d="M13.2 14.7502H6.40002" stroke="#FEFBFB" />
        <path d="M8.10002 7.94995H7.25002H6.40002" stroke="#FEFBFB" />
        <path d="M11.5 2V7.09999H16.6" stroke="#FEFBFB" />
        <path d="M13.2 11.3501H6.40002" stroke="#FEFBFB" />
        <path d="M13.2 14.7502H6.40002" stroke="#FEFBFB" />
        <path d="M8.10002 7.94995H7.25002H6.40002" stroke="#FEFBFB" />
      </svg>,
      submenu: [],
    },
    {
      title: 'Solicitação',
      link: '/solicitacoes',
      icon: <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M23.1898 4.63553L20.5601 2.12708V22.093V22.6388H19.9871H0.956905H0.383911V22.093V17.1913H1.5299V21.5473H19.4141V2.07551L16.7551 4.64449L15.9403 3.88133L19.5466 0.397172L19.9515 0.00610352L20.3592 0.395023L24 3.86808L23.1898 4.63553Z" fill="white" />
        <path d="M11.5 2H4.7C4.24913 2 3.81673 2.17911 3.49792 2.49792C3.17911 2.81673 3 3.24913 3 3.7V17.3C3 17.7508 3.17911 18.1832 3.49792 18.502C3.81673 18.8209 4.24913 19 4.7 19H14.9C15.3508 19 15.7832 18.8209 16.1021 18.502C16.4209 18.1832 16.6 17.7508 16.6 17.3V7.09999L11.5 2Z" stroke="#FEFBFB" />
        <path d="M11.5 2V7.09999H16.6" stroke="#FEFBFB" />
        <path d="M13.2 11.3501H6.40002" stroke="#FEFBFB" />
        <path d="M13.2 14.7502H6.40002" stroke="#FEFBFB" />
        <path d="M8.10002 7.94995H7.25002H6.40002" stroke="#FEFBFB" />
        <path d="M11.5 2V7.09999H16.6" stroke="#FEFBFB" />
        <path d="M13.2 11.3501H6.40002" stroke="#FEFBFB" />
        <path d="M13.2 14.7502H6.40002" stroke="#FEFBFB" />
        <path d="M8.10002 7.94995H7.25002H6.40002" stroke="#FEFBFB" />
      </svg>,
      submenu: [],
    },
  ];
  if (movideskId) {
    options.push({
      title: 'Suporte',
      link: '/tickets',
      icon:
        <svg width="25" height="25" viewBox="0 0 30 30" fill="none"
          stroke="#fff" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
          <path d="M16,2C9.4,2,4,7.3,4,13.9v3.5c0,0.1,0,0.1,0,0.2c0,0.1,0,0.3,0,0.4c0,2.8,2.2,5,5,5c0.6,0,1-0.4,1-1v-8c0-0.6-0.4-1-1-1
        c-1.1,0-2.2,0.4-3,1v-0.2C6,8.4,10.5,4,16,4s10,4.4,10,9.9V14c-0.8-0.6-1.9-1-3-1c-0.6,0-1,0.4-1,1v8c0,0.6,0.4,1,1,1
        c0.7,0,1.4-0.2,2-0.4c-1,2.1-2.8,3.7-5,4.6c0-0.1,0-0.1,0-0.2c0-0.6-0.4-1-1-1h-3c-0.6,0-1,0.4-1,1v2c0,0.6,0.4,1,1,1
        c6.6,0,12-5.2,12-11.6v-1V15v-1.1C28,7.3,22.6,2,16,2z"/>
        </svg>,
      submenu: [],
    })
  }
  options.push({
    title: 'Ajuda',
    link: '/ajuda',
    icon:
      <svg fill="#fff" width="25" height="30" viewBox="0 0 230 260">
        <g>
          <path d="M109.575,0C49.156,0,0.002,49.155,0.002,109.574c0,60.42,49.154,109.576,109.573,109.576s109.573-49.156,109.573-109.576
        C219.148,49.155,169.994,0,109.575,0z M109.575,204.15c-52.148,0-94.573-42.427-94.573-94.576C15.002,57.426,57.427,15,109.575,15
        s94.573,42.426,94.573,94.574C204.148,161.724,161.723,204.15,109.575,204.15z
        M109.576,152.243c-5.738,0-10.406,4.667-10.406,10.403c0,5.743,4.668,10.415,10.406,10.415
        c5.738,0,10.406-4.672,10.406-10.415C119.982,156.91,115.314,152.243,109.576,152.243z M109.576,167.243
        c-2.533,0-4.594-2.063-4.594-4.597c0-2.528,2.061-4.585,4.594-4.585s4.594,2.057,4.594,4.585
        C114.17,165.181,112.109,167.243,109.576,167.243z
        M109.575,46.089c-19.154,0-34.737,15.583-34.737,34.736c0,4.142,3.358,7.5,7.5,7.5c4.142,0,7.5-3.358,7.5-7.5
        c0-10.883,8.854-19.736,19.737-19.736c10.884,0,19.738,8.854,19.738,19.736c0,10.883-8.854,19.737-19.738,19.737
        c-4.142,0-7.5,3.358-7.5,7.5v27.122c0,4.142,3.358,7.5,7.5,7.5s7.5-3.358,7.5-7.5v-20.447c15.56-3.439,27.238-17.333,27.238-33.913
        C144.313,61.672,128.73,46.089,109.575,46.089z"
          />
        </g>
      </svg>,
    submenu: [],
  });
  if (device === "mobile") {
    options.push({
      title: 'Logout',
      link: 'logout',
      icon:
        <svg width="30" height="30" viewBox="0 0 33 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M30.8581 14.6686L26.4987 10.4499C26.4537 10.4063 26.4004 10.3718 26.3416 10.3482C26.2828 10.3246 26.2199 10.3125 26.1562 10.3125C26.0926 10.3125 26.0297 10.3246 25.9709 10.3482C25.9121 10.3718 25.8587 10.4063 25.8138 10.4499L24.3607 11.8561C24.3157 11.8996 24.28 11.9513 24.2556 12.0081C24.2313 12.065 24.2187 12.126 24.2187 12.1875C24.2187 12.2491 24.2313 12.31 24.2556 12.3669C24.28 12.4238 24.3157 12.4754 24.3607 12.5189L25.4713 13.5938H15.5C15.3715 13.5938 15.2483 13.6432 15.1575 13.7311C15.0667 13.819 15.0156 13.9382 15.0156 14.0625C15.0156 14.1868 15.0667 14.3061 15.1575 14.394C15.2483 14.4819 15.3715 14.5313 15.5 14.5313H26.6406C26.7364 14.5312 26.83 14.5037 26.9097 14.4522C26.9893 14.4007 27.0514 14.3275 27.088 14.2419C27.1247 14.1562 27.1343 14.062 27.1156 13.9711C27.0969 13.8802 27.0508 13.7967 26.9831 13.7311L25.3881 12.1875L26.1562 11.4441L29.8307 15L26.1562 18.5559L25.3881 17.8125L26.9831 16.2689C27.0508 16.2034 27.0969 16.1199 27.1156 16.0289C27.1343 15.938 27.1247 15.8438 27.088 15.7581C27.0514 15.6725 26.9893 15.5993 26.9097 15.5478C26.83 15.4963 26.7364 15.4688 26.6406 15.4688H15.5C15.3715 15.4688 15.2483 15.5182 15.1575 15.6061C15.0667 15.694 15.0156 15.8132 15.0156 15.9375C15.0156 16.0618 15.0667 16.1811 15.1575 16.269C15.2483 16.3569 15.3715 16.4063 15.5 16.4063H25.4713L24.3607 17.4811C24.3157 17.5246 24.28 17.5763 24.2556 17.6331C24.2313 17.69 24.2187 17.751 24.2187 17.8125C24.2187 17.8741 24.2313 17.935 24.2556 17.9919C24.28 18.0488 24.3157 18.1004 24.3607 18.1439L25.8138 19.5502C25.8588 19.5937 25.9121 19.6283 25.9709 19.6518C26.0297 19.6754 26.0926 19.6875 26.1562 19.6875C26.2198 19.6875 26.2828 19.6754 26.3416 19.6518C26.4004 19.6283 26.4537 19.5937 26.4987 19.5502L30.8581 15.3314C30.9031 15.2879 30.9388 15.2363 30.9631 15.1794C30.9875 15.1225 31 15.0616 31 15C31 14.9385 30.9875 14.8775 30.9631 14.8206C30.9388 14.7638 30.9031 14.7121 30.8581 14.6686Z" fill="white" />
          <path d="M21.7969 17.3435C21.6684 17.3435 21.5452 17.3929 21.4544 17.4808C21.3635 17.5687 21.3125 17.6879 21.3125 17.8123V26.2498H11.625V3.74977H21.3125V12.1873C21.3125 12.3116 21.3635 12.4308 21.4544 12.5187C21.5452 12.6066 21.6684 12.656 21.7969 12.656C21.9253 12.656 22.0485 12.6066 22.1394 12.5187C22.2302 12.4308 22.2812 12.3116 22.2812 12.1873V3.28102C22.2812 3.1567 22.2302 3.03747 22.1394 2.94956C22.0485 2.86165 21.9253 2.81227 21.7969 2.81227H11.625V0.468516C11.625 0.394339 11.6069 0.321214 11.572 0.255151C11.5372 0.189089 11.4866 0.131975 11.4245 0.0885038C11.3624 0.0450331 11.2905 0.0164468 11.2147 0.00509474C11.139 -0.00625733 11.0616 -5.10733e-05 10.9888 0.0232034L0.332523 3.42942C0.235728 3.46035 0.151482 3.52004 0.0917785 3.59999C0.0320751 3.67994 -4.19323e-05 3.77609 4.10885e-08 3.87473V26.1248C-4.19323e-05 26.2234 0.0320751 26.3196 0.0917785 26.3995C0.151482 26.4795 0.235728 26.5392 0.332523 26.5701L10.9888 29.9763C11.0616 29.9996 11.139 30.0058 11.2147 29.9944C11.2905 29.9831 11.3624 29.9545 11.4245 29.911C11.4866 29.8676 11.5372 29.8104 11.572 29.7444C11.6069 29.6783 11.625 29.6052 11.625 29.531V27.1873H21.7969C21.9253 27.1873 22.0485 27.1379 22.1394 27.05C22.2302 26.9621 22.2812 26.8428 22.2812 26.7185V17.8123C22.2812 17.6879 22.2302 17.5687 22.1394 17.4808C22.0485 17.3929 21.9253 17.3435 21.7969 17.3435ZM10.6562 28.8826L0.968749 25.786V4.2135L10.6562 1.11694V28.8826Z" fill="white" />
          <path d="M8.23437 13.5938C7.94697 13.5938 7.66603 13.6762 7.42706 13.8307C7.1881 13.9853 7.00185 14.2049 6.89186 14.4619C6.78188 14.7188 6.7531 15.0016 6.80917 15.2743C6.86524 15.5471 7.00364 15.7977 7.20686 15.9944C7.41008 16.191 7.66901 16.325 7.95088 16.3792C8.23276 16.4335 8.52494 16.4056 8.79046 16.2992C9.05598 16.1928 9.28293 16.0125 9.4426 15.7813C9.60227 15.55 9.6875 15.2781 9.6875 15C9.68707 14.6272 9.53384 14.2697 9.26142 14.0061C8.989 13.7424 8.61964 13.5942 8.23437 13.5938ZM8.23437 15.4687C8.13857 15.4687 8.04493 15.4413 7.96527 15.3898C7.88562 15.3382 7.82353 15.265 7.78687 15.1794C7.75021 15.0937 7.74062 14.9995 7.75931 14.9086C7.778 14.8176 7.82413 14.7341 7.89187 14.6685C7.95961 14.603 8.04592 14.5583 8.13988 14.5403C8.23384 14.5222 8.33123 14.5315 8.41974 14.5669C8.50824 14.6024 8.58389 14.6625 8.63712 14.7396C8.69034 14.8167 8.71875 14.9073 8.71875 15C8.71863 15.1243 8.66756 15.2434 8.57675 15.3313C8.48594 15.4192 8.3628 15.4686 8.23437 15.4687Z" fill="white" />
        </svg>
      , submenu: []
    });
  }

  return (
    <BrowserRouter {...(props.useBasename ? { basename: 'cliente' } : {})}>
      <>
        <div className="app-container" >
          {signed ? (
            <>
              <TopMenu />
              <SideMenu
                device={device}
                options={options}
              />
              <Switch>
                <Route exact path="/" component={Home} />
                <Route exact path="/home" component={Home} />
                <Route exact path="/recomendacoes" component={Listagem} />
                <Route
                  exact
                  path="/visualizar-recomendacoes/:id?"
                  component={Vizualizar}
                />

                <Route
                  exact
                  path="/solicitacoes"
                  component={ListagemSolicitacoes}
                />
                <Route
                  exact
                  path="/visualizar-solicitacoes/:id?"
                  component={VisualizarSolicitacoes}
                />

                <Route exact path="/conta" component={MinhaConta} />

                <Route exact path="/ajuda" component={Ajuda} />

                <Route exact path="/tickets" component={Tickets} />
                <Route exact path="/criar-ticket" component={CriarTicket} />

                <Route component={NotFound} />
              </Switch>
            </>
          ) : (
            <>
              <Switch>
                <Route path="/" exact component={UsuarioLogin} />
                <Route path="/esqueci" exact component={Esqueci} />
                <Route path="/nova-senha/:id?" exact component={NovaSenha} />
                <Route component={NotFound} />
              </Switch>
            </>)}
        </div>
      </>
    </BrowserRouter>
  );
}

export default UsuarioRoutes;